var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _polygon3, _polygon4, _path9, _path10, _polygon5, _polygon6, _path11, _path12, _path13, _polygon7, _path14, _path15, _polygon8, _polygon9, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Badges",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 40",
    style: {
      enableBackground: "new 0 0 128 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124,40H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h120c2.2,0,4,1.8,4,4v32C128,38.2,126.2,40,124,40z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.2579,
    y1: 35.4241,
    x2: 21.8561,
    y2: 12.4332,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006884"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8AD1D0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,19.6V9.1c0-0.6,0.5-1.1,1-1.1s0.7,0.1,1,0.3l19.3,10.6c0.4,0.2,0.6,0.5,0.6,0.8s-0.2,0.6-0.6,0.8   L11.8,31.1c-0.2,0.1-0.5,0.3-1,0.3s-1-0.5-1-1.1V19.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.4263,
    y1: 32.1296,
    x2: 24.6823,
    y2: 23.8821,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24BBB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBE692"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.3,19.7L10.6,8c0.1,0,0.1,0,0.2,0c0.5,0,0.7,0.1,1,0.3L26,16.1L22.3,19.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 27,
    y1: 18.3799,
    x2: 27,
    y2: 26.3283,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCC072"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58A5B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.9,23.2l-3.6-3.6l3.7-3.7l5.1,2.8c0.4,0.2,0.6,0.5,0.6,0.8s-0.2,0.6-0.6,0.8L25.9,23.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.3651,
    y1: 8.76,
    x2: 24.4168,
    y2: 21.0252,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#712B8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA1D27"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.7,31.2L10.7,31.2l11.6-11.6l3.6,3.6l-14.1,7.7C11.5,31.1,11.3,31.2,10.7,31.2   C10.8,31.2,10.8,31.2,10.7,31.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.1,33.9c-0.5-0.4-0.9-1.1-1.1-1.5l1.6-0.7c0.1,0.2,0.3,0.5,0.5,0.8c0.4,0.4,1,0.8,1.6,0.8s1.3-0.3,1.7-0.8   c0.3-0.5,0.5-1,0.5-1.7v-0.6c-1.2,1.5-3.7,1.3-5.1-0.3c-1.5-1.6-1.5-4.3,0-5.9c1.5-1.5,3.7-1.7,5-0.3l0,0V23h1.7v7.5   c0,1.9-0.7,3-1.6,3.7c-0.6,0.5-1.5,0.7-2.3,0.7C72.7,34.8,71.8,34.5,71.1,33.9L71.1,33.9z M113,34.3L113,34.3l1.7-4l-3-6.9h1.7   l2.1,4.9l2.1-4.9h1.7l-4.6,10.9L113,34.3L113,34.3z M104.9,30.5L104.9,30.5c-0.5-0.5-0.7-1.2-0.7-1.9c0-0.6,0.2-1.2,0.6-1.6   c0.7-0.7,1.7-1,2.8-1c0.7,0,1.3,0.1,1.8,0.4c0-1.2-1-1.7-1.8-1.7c-0.7,0-1.4,0.4-1.7,1.1l-1.5-0.6c0.3-0.7,1.1-2,3.1-2   c1,0,2,0.3,2.6,1s0.8,1.5,0.8,2.6V31h-1.7v-0.7c-0.2,0.3-0.6,0.5-0.9,0.7c-0.4,0.2-0.9,0.3-1.4,0.3C106.3,31.2,105.4,31,104.9,30.5   L104.9,30.5z M51.6,26.9L51.6,26.9c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2s-1.5,4.2-4.2,4.2C53.1,31.1,51.6,28.9,51.6,26.9   L51.6,26.9z M60.6,26.9L60.6,26.9c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2s-1.5,4.2-4.2,4.2C62.2,31.1,60.6,28.9,60.6,26.9   L60.6,26.9z M40.3,29.1L40.3,29.1c-2.5-2.5-2.4-6.6,0.1-9.2c1.3-1.3,2.9-1.9,4.6-1.9c1.6,0,3.2,0.6,4.4,1.8l-1.2,1.3   c-1.8-1.8-4.7-1.7-6.4,0.1c-1.8,1.9-1.8,4.8,0,6.7s4.8,2,6.6,0.1c0.6-0.6,0.8-1.4,0.9-2.2h-4.2V24H51c0.1,0.4,0.1,0.9,0.1,1.4   c0,1.5-0.6,3-1.6,4c-1.1,1.1-2.7,1.7-4.3,1.7C43.4,31,41.6,30.4,40.3,29.1L40.3,29.1z M82.6,29.8L82.6,29.8c-1.5-1.6-1.5-4.3,0-6   c1.5-1.6,4-1.6,5.4,0c0.5,0.5,0.8,1.2,1.1,1.9L83.6,28c0.3,0.7,1,1.3,2,1.3c0.9,0,1.5-0.3,2.1-1.2l1.5,1l0,0   c-0.2,0.2-0.4,0.4-0.5,0.6C87,31.4,84.1,31.4,82.6,29.8L82.6,29.8z M93,31L93,31V19.9h3.6c2.1,0,3.8,1.5,3.8,3.3s-1.5,3.3-3.4,3.3   h-2.2v4.4L93,31L93,31z M101.4,31L101.4,31V19.9h1.7V31H101.4L101.4,31z M78.8,30.8L78.8,30.8V18.4h1.8v12.4L78.8,30.8L78.8,30.8z    M109.3,27.7L109.3,27.7c-0.4-0.3-1-0.4-1.6-0.4c-1.2,0-1.9,0.6-1.9,1.3s0.7,1.1,1.4,1.1C108.2,29.7,109.3,28.9,109.3,27.7   L109.3,27.7z M58.1,26.9L58.1,26.9c0-1.2-0.8-2.5-2.3-2.5s-2.3,1.3-2.3,2.5s0.8,2.5,2.3,2.5C57.2,29.4,58.1,28.1,58.1,26.9   L58.1,26.9z M67.1,26.9L67.1,26.9c0-1.2-0.8-2.5-2.3-2.5s-2.3,1.3-2.3,2.5s0.8,2.5,2.3,2.5S67.1,28.1,67.1,26.9L67.1,26.9z    M76,27.6L76,27.6c0-0.1,0-0.2,0.1-0.3l0,0c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4v-0.1c0-0.1-0.1-0.3-0.1-0.4   c-0.3-1-1.2-1.7-2.1-1.7c-1.2,0-2.2,1.2-2.2,2.5c0,1.4,1,2.5,2.3,2.5C74.8,29.4,75.6,28.7,76,27.6L76,27.6z M83.3,26.7L83.3,26.7   l3.7-1.6c-0.4-0.7-1-0.9-1.5-0.9C84,24.3,83.1,25.9,83.3,26.7L83.3,26.7z M98.6,23.3L98.6,23.3c0-1-0.8-1.7-1.9-1.7h-2v3.5h2.1   C97.8,25.1,98.6,24.3,98.6,23.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.3,32.3 114.3,32.3 114.2,32.3 114.2,32.3 114.2,32.2 114.2,32.2 114.3,32.2 114.3,32.2    114.2,32.2 114.2,32.2 114.2,32.3 114.2,32.3  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.3,32.3L114.3,32.3C114.3,32.2,114.3,32.2,114.3,32.3L114.3,32.3C114.3,32.2,114.3,32.2,114.3,32.3   L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3z M114.3,32.2L114.3,32.2L114.3,32.2   L114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.3,32.3 114.3,32.3 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2    114.3,32.2 114.3,32.2 114.3,32.3  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3   L114.3,32.3z M114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2L114.3,32.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.3 114.3,32.3 114.3,32.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.3,32.3 114.3,32.3 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2 114.3,32.2    114.3,32.2 114.3,32.2 114.3,32.3  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.3,32.3L114.3,32.3C114.3,32.2,114.3,32.2,114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3   L114.3,32.3z M114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3L114.3,32.3C114.3,32.2,114.3,32.2,114.3,32.3L114.3,32.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.4,32.3L114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3   C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3z M114.4,32.2L114.4,32.2L114.4,32.2   L114.4,32.2L114.4,32.2L114.4,32.2L114.4,32.2L114.4,32.2L114.4,32.2z M114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3   L114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.4,32.2 114.4,32.2 114.4,32.2 114.4,32.2 114.4,32.2 114.4,32.2 114.4,32.2 114.4,32.2    114.4,32.3 114.4,32.3  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.4,32.3 114.4,32.3 114.4,32.2 114.4,32.2 114.4,32.3  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.4,32.3L114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3   L114.4,32.3L114.4,32.3L114.4,32.3z M114.4,32.2L114.4,32.2C114.4,32.3,114.4,32.3,114.4,32.2C114.4,32.3,114.4,32.3,114.4,32.2   L114.4,32.2L114.4,32.2L114.4,32.2L114.4,32.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3   C114.4,32.2,114.4,32.2,114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3C114.4,32.2,114.4,32.2,114.4,32.3   C114.4,32.2,114.4,32.2,114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3L114.4,32.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.5,32.3L114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3C114.4,32.2,114.4,32.2,114.5,32.3L114.5,32.3   C114.4,32.3,114.4,32.3,114.5,32.3L114.5,32.3L114.5,32.3z M114.5,32.2L114.5,32.2C114.5,32.3,114.5,32.3,114.5,32.2   C114.5,32.3,114.4,32.3,114.5,32.2L114.5,32.2C114.4,32.2,114.5,32.2,114.5,32.2L114.5,32.2L114.5,32.2z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.5,32.3 114.5,32.2 114.5,32.2 114.5,32.2 114.5,32.2 114.5,32.2 114.5,32.3 114.5,32.3    114.5,32.2 114.5,32.2 114.5,32.3 114.5,32.3 114.5,32.2 114.5,32.2  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3L114.5,32.3   L114.5,32.3z M114.5,32.2L114.5,32.2L114.5,32.2L114.5,32.2L114.5,32.2L114.5,32.2L114.5,32.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3   C114.5,32.2,114.5,32.2,114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3L114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3   C114.5,32.2,114.5,32.2,114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3C114.5,32.2,114.5,32.2,114.5,32.3L114.5,32.3L114.5,32.3   L114.5,32.3L114.5,32.3L114.5,32.3z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.6,32.2 114.5,32.2 114.5,32.2 114.6,32.2 114.6,32.3 114.6,32.3 114.6,32.2  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "114.6,32.3 114.6,32.3 114.6,32.2 114.6,32.2 114.6,32.2 114.6,32.2 114.6,32.2 114.6,32.2    114.6,32.2 114.6,32.2 114.6,32.3  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.6,32.3L114.6,32.3C114.6,32.2,114.6,32.2,114.6,32.3L114.6,32.3C114.6,32.2,114.6,32.2,114.6,32.3   L114.6,32.3L114.6,32.3L114.6,32.3L114.6,32.3L114.6,32.3L114.6,32.3L114.6,32.3L114.6,32.3z M114.6,32.2L114.6,32.2L114.6,32.2   L114.6,32.2L114.6,32.2L114.6,32.2L114.6,32.2L114.6,32.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.9,10.1c0-1.8,1.3-2.9,2.9-2.9c1.1,0,1.8,0.5,2.3,1.2l-0.8,0.5c-0.3-0.4-0.8-0.7-1.5-0.7   c-1.1,0-1.9,0.8-1.9,2s0.8,2,1.9,2c0.6,0,1.1-0.3,1.3-0.5v-0.9h-1.6V9.9h2.7V12c-0.5,0.6-1.3,1-2.3,1C40.2,13,38.9,11.8,38.9,10.1z   "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.4,12.9V7.3h3.8v0.9h-2.9v1.4h2.8v0.9h-2.8v1.6h2.9V13L45.4,12.9L45.4,12.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52,12.9V8.2h-1.7V7.3h4.4v0.9H53v4.7C53,12.9,52,12.9,52,12.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.1,12.9V7.3h1v5.6H58.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.8,12.9V8.2h-1.7V7.3h4.4v0.9h-1.7v4.7C62.8,12.9,61.8,12.9,61.8,12.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.7,10.1c0-1.7,1.2-2.9,2.9-2.9s2.9,1.2,2.9,2.9S72.3,13,70.6,13C68.9,13,67.7,11.7,67.7,10.1z M72.4,10.1   c0-1.2-0.7-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.7,2,1.9,2C71.7,12.1,72.4,11.2,72.4,10.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.5,12.9l-2.9-4v4h-1V7.3h1l2.9,3.9V7.3h1v5.6H78.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.f120f2db484549f15b77fac70895785e.svg";
export { ForwardRef as ReactComponent };